import React from 'react';
import BadgesPage from '../components/Awards/BadgesPage';

/* /teacher/badges: my badges & medals + the Wall of fame */
const TeacherBadges = () => <BadgesPage mode="teacher" />;

export default TeacherBadges;
